// core
import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from "rxjs";

// services
import { RaptorInterstitialService } from '../../services/raptor-interstitial.service';
import { RaptorFormService } from '../../services/raptor-form.service';


@Component({
  selector: 'open-raptor-medical',
  templateUrl: './raptor-medical.component.html',
  styleUrls: ['./raptor-medical.component.scss']
})
export class RaptorMedicalComponent implements OnInit, OnDestroy {
  @Input() question!: any;
  @Input() form!: FormGroup;

  ratorUpdateSubscription!: Subscription;

  constructor(
    private raptorFormService: RaptorFormService,
    private raptorInterstitialService: RaptorInterstitialService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.ratorUpdateSubscription = this.raptorFormService.update$
      .subscribe((data: any) => {
        // the component is not picking up the new data binding so explicitly tell
        // angular to detect this change
        // I may want to broaden this implementation to other raptor elements
        // if the data mapping from the update ever fails on another component
        this.changeDetectorRef.detectChanges();
      });
  }

  ngOnDestroy(): void {
    if (this.ratorUpdateSubscription) {
      this.ratorUpdateSubscription.unsubscribe();
    }
  }

  openMedical(): void {
    this.raptorInterstitialService.openMedicalInterstitial(this.form, this.question);
  }

  get buttonLabel() {
    return this.question.conditions && this.question.conditions.length ?
    (this.question.settings && this.question.settings.resume_text) || 'Resume medical screening' :
    (this.question.settings && this.question.settings.start_text) || 'Start medical screening';
  }
}
